import React, { useEffect, useRef, useState } from 'react';
import { useDoctorQuery } from '../../hooks/useDoctorQuery';
import drEasyApi from '../../Api/Customapi';
import { useDoctorContext } from '../../context/DoctorContext';
import NewsCard from '../Cards/NewsCard';
import { useTranslation } from 'react-i18next';
import { Newspaper } from 'lucide-react';

const LIMIT = 3;

export default function NewsSection() {
    const { t } = useTranslation();
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const { data: doctor } = useDoctorQuery();
    const { setHasNews } = useDoctorContext();
    const sectionRef = useRef(null);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await drEasyApi.get('/api/CenterNews/GetCenterNews', {
                    params: { CenterId: doctor?.id },
                });
                setNews(res.data || []);
                if (res?.data?.length > 0) {
                    setHasNews(true);
                }
            } catch (err) {
                console.error('Failed to load news', err);
            } finally {
                setLoading(false);
            }
        };

        if (doctor?.id) fetchBlogs();
    }, [doctor?.id]);

    if (!loading && news?.length === 0) {
        setHasNews(false);
        return null;
    }

    const displayedNews = showAll ? news : news.slice(0, LIMIT);
    const hasMore = news.length > LIMIT;

    const handleToggle = () => {
        if (showAll) {
            sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setShowAll((prev) => !prev);
    };

    return (
        <section
            ref={sectionRef}
            className="bg-cardColor py-4 md:py-16 px-4 max-w-8xl   md:min-h-screen flex flex-col justify-center items-center"
        >
            <div className="w-full max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
            <div className="text-center mb-14">
        <h2 className=" text-2xl md:text-4xl font-bold text-center goldy flex items-center justify-center gap-3">
                        <Newspaper className="text-3xl text-primary_hover" />
            
                    {t('news.title')}
                </h2>
            </div>

            {loading ? (
                <div className="text-center text-textPrimary">{t('news.loading')}</div>
            ) : (
                <div
                 className=" mx-auto px-4 grid gap-4 md:gap-8 justify-center items-center grid-cols-2 sm:grid-cols-2 md:grid-cols-3"
                 >
                    {displayedNews.map((item, index) => (
                        <NewsCard
                            key={index}
                            title={item.title}
                            summary={item.description}
                            date={item.date}
                            image={item.photoID}
                            index={index}
                        />
                    ))}
                </div>
            )}

            {hasMore && (
                <div className="flex justify-center items-center mt-0">
                    <button
                        onClick={handleToggle}
className="bg-white border-2 border-primary font-semibold py-2 sm:py-3 px-4 sm:px-8 rounded-lg hover:bg-cardColor hover:scale-105 text-primary text-xs sm:text-sm transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-1.5 sm:gap-2 mx-auto"                    >
                        {showAll ? t('news.seeLess') : t('news.seeMore')}
                    </button>
                </div>
            )}
            </div>
        </section>
    );
}